import React, {useState} from 'react';
import {Button, Form, Input} from 'antd';
import {MailOutlined, LockOutlined} from '@ant-design/icons';
import {getPublicImagePath, useAppDispatch, useAppState} from '@nutastic/nutastic-react-app';
import {logIntoApplication} from '../../../state/actions.mjs';
import AccountValidationForm from "./AccountValidationForm";
import LoginForm from "./LoginForm";
import {ReactSVG} from "react-svg";

const componentClass = 'loginFlow';

const FLOW_STEPS = {
    VALIDATE: 'VALIDATE',
    LOGIN: 'LOGIN',
    PROMPT: 'PROMPT'
}

export const LoginFlow = ({ onComplete }) => {
    const [currentStep, setCurrentStep] = useState(FLOW_STEPS.VALIDATE);
    const [nuAccountEmail, setNuAccountEmail] = useState('');

    const onFlowComplete = () => {
        onComplete(nuAccountEmail);
    }

    const renderValidationStep = () => {
        const onValidationComplete = (email, isValid) => {
            setNuAccountEmail(email);
            setCurrentStep(isValid ? FLOW_STEPS.LOGIN : FLOW_STEPS.PROMPT);
        }
        return <AccountValidationForm onValidationComplete={onValidationComplete} emailValue={nuAccountEmail} />;
    };

    const renderLoginStep = () => {
        return <LoginForm
            onLoginComplete={onFlowComplete}
            onCancel={() => setCurrentStep(FLOW_STEPS.VALIDATE)}
            hideEmailField={true}
            emailValue={nuAccountEmail}
        />;
    };

    const renderPrompt = () => {
        const elementClass = "loginFlowPrompt";
        return <div className={elementClass}>
            <h2>Nu Account Notice</h2>
            <p>Looks like you are a Nu visitor on our planet! Thanks for coming to spend some love with us. Once you complete
            your purchase, the email below will used to setup your account. Click continue to proceed.</p>
            <div className={`${elementClass}__emailToUse`}><b>Your Nu Account Email: </b> <span>{ nuAccountEmail }</span></div>
            <div className={`${elementClass}__buttons nuButtonGroup`}>
                <button className="btn btn-block btn-outlined btn-outline-black" onClick={() => setCurrentStep(FLOW_STEPS.VALIDATE)}>
                    <i className="fa fa-arrow-circle-o-left" /> <span>Change Email</span>
                </button>
                <button className="btn btn-block btn-primary" onClick={onFlowComplete}>
                    <span>Continue</span> <i className="fa fa-arrow-circle-o-right" />
                </button>
            </div>
        </div>
    };

    const renderLoginFlowStep = () => {
        if (currentStep === FLOW_STEPS.VALIDATE) {
            return renderValidationStep();
        } else if (currentStep === FLOW_STEPS.LOGIN) {
            return renderLoginStep();
        } else if (currentStep === FLOW_STEPS.PROMPT) {
            return renderPrompt();
        }
        return null;
    };

    return <div className={componentClass}>
        <div className={`${componentClass}__wrapper`}>
            <ReactSVG src={ getPublicImagePath('nutastic-emblem.svg') } className={`${componentClass}__logo`} />
            { renderLoginFlowStep() }
        </div>
    </div>;
};

export default LoginFlow;
